// extracted by mini-css-extract-plugin
export default {"container":"PostView-module__container--JmhOh","postSeriesBarContainer":"PostView-module__postSeriesBarContainer--8jmOb"};